export interface LinkField {
  id: string
  url: string
  linktype: string
  fieldtype: string
  cached_url: string
  target: string
}

// generate URLs for links
export function linkUrl(link: LinkField): string {
  if (!link) return ''

  if (link?.linktype === 'url' && (link?.url === undefined || link?.url === '')) return ''

  // if linktype is 'email', return mailto link
  if (link?.linktype === 'email') {
    return `mailto:${link.url}`
  }

  // if linktype is 'url' and cached_url begins with www. then add https://
  if (link?.linktype === 'url' && link.cached_url.startsWith('www.')) {
    return `https://${link.cached_url}`
  }

  //if linktype is story we want to ensure that it always starts with /
  if (link?.linktype == 'story') {
    // strip out en-nz/ from cached_url
    let updateLink = link.cached_url.replace('en-nz/', '')
    // check if cached_url starts with /
    if (updateLink.startsWith('/')) return updateLink

    return `/${updateLink}`
  }

  return link?.cached_url
}
